import { Game } from "../types/game";
import { loadGameFromCloud, saveGameInCloud } from "./database";
import { loadGameFromLocalStorage, saveGameInLocalStorage } from "./localSave";

export function loadGame(uid: string | undefined) {
  if (uid) {
    const game = loadGameFromCloud(uid);
    if (game) {
      return game.then((game) => {
        console.log("Game loaded from cloud", game);

        return game;
      });
    }
  } else {
    const game = loadGameFromLocalStorage();
    console.log("Game loaded from local storage", game);
    return game;
  }
}

export function saveGame(uid: string | undefined, game: Game) {
  const gameData = {
    ...game,
    producers: game.producers.map((producer) => ({
      ...producer,
      value: producer.value.toString(),
    })),
    molecule: { ...game.molecule, value: game.molecule.value.toString() },
    unlockedAchievementIds: Array.from(game.unlockedAchievementIds),
    last10MoleculeCreations: game.last10MoleculeCreations.map((creation) => ({
      ...creation,
      molecules: creation.molecules.toString(),
    })),
    timestamp: Date.now(),
  };
  if (uid) {
    saveGameInCloud(uid, gameData);
  }
  saveGameInLocalStorage(gameData);
}
